import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { FormMAsterService } from './../../services/formMaster.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CreateFormComponent } from '../create/create.component';
import { GetFormMasterFieldsComponent } from '../get.fields/get.component';
import { GetFormMasterFieldsPopupComponent } from '../get.fields.popup/get.component';
import { UpdateFormComponent } from '../update/update.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsmaster-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormMasterComponent extends BaseComponent implements OnInit {
  constructor(
    public route: Router,
    public service: FormMAsterService,
    public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private aRoute: ActivatedRoute
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/sections/' + id]);
  }

  addForm() {
    this.diag.open(CreateFormComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

  active(id) {
    this.service.post({ id: id }, '/Apply').subscribe(
      (res) => {
        this.toast.success('Active form successfully', 'sucess', { duration: 4000 });
      },
      (err) => {
        this.toast.danger('Failed To active form', 'Failed', { duration: 4000 });
      }
    );
  }

  show(id, shpwOption = 1) {
    if (shpwOption === 1) this.diag.open(GetFormMasterFieldsPopupComponent, { context: { formId: id } });
    else this.route.navigate(['admin/dynamicForms/preview/' + id]);
  }

  update(formId) {
    this.diag.open(UpdateFormComponent, { context: { dformId: formId } }).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

  delete(id) {
    this.service.delete(id).subscribe(
      (res) => {
        this.toast.success('Form deleted successfully');
        this.loadEntities();
      },
      (err) => {
        this.toast.danger('Failed to delete this form');
      }
    );
  }
}
